import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { simpleVehicleGroupSchema } from '../schemas/vehicle-group.schema';

/**
 * Requests the Vehicle Groups associated with a specific Place Set
 * @param setId The ID of the Place Set whose Vehicle Groups are being requested
 * @returns An array of Vehicle Groups
 */
export function getPlaceSetsIdVehicleGroups(this: unknown, setId: number) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment.resolve(this).placeSetsIdVehicleGroupsUrl(setId),
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(simpleVehicleGroupSchema),
      })
    )
  );
}
